export { default } from './StudentsPerformance';



// WEBPACK FOOTER //
// ./src/components/DataCentre/StudentsPerformance/index.ts